var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.11 1.704L2.82 4.997l3.3 3.301c.39.39.39 1.022 0 1.412-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.3L0 4.997 4.7.292c.39-.39 1.02-.39 1.41 0 .39.39.39 1.022 0 1.412zm3.78 6.592l3.29-3.292L9.88 1.7c-.39-.39-.39-1.02 0-1.41.2-.19.45-.291.71-.291.26 0 .51.1.71.3L16 5.004l-4.7 4.703c-.39.39-1.02.39-1.41 0-.39-.39-.39-1.02 0-1.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.5a4e360a260a3a32009a473afd61b88f.svg";
export { ForwardRef as ReactComponent };